import { render } from "./Download.vue?vue&type=template&id=02b5934b&scoped=true"
import script from "./Download.vue?vue&type=script&lang=ts"
export * from "./Download.vue?vue&type=script&lang=ts"

import "./Download.vue?vue&type=style&index=0&id=02b5934b&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-02b5934b"

export default script